import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '/', // .env.*에서 설정
  timeout: 10000,
  withCredentials: false,
});

// (옵션) 요청/응답 인터셉터
// api.interceptors.request.use(cfg => { /* 토큰 헤더 등 */ return cfg; });
// api.interceptors.response.use(r => r, e => Promise.reject(e));

export default {
  install(app) {
    // 원하는 키에 붙이세요. (요청대로 this.axios)
    app.config.globalProperties.axios = api;
    // 필요하면 this.$http로도
    // app.config.globalProperties.$http = api;
  },
};

export { api };